var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:[
        'inline-flex items-start gap-2 leading-none',
        _vm.labelBefore ? 'flex-row-reverse' : '',
        _vm.disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'
    ]},[_c('input',{staticClass:"sr-only",attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.isChecked},on:{"change":_vm.onChange}}),_c('span',{class:[
            'flex-shrink-0 w-5 h-5 rounded border-2 flex items-center justify-center transition-colors',
            _vm.isChecked
                ? [_vm.colorClass, 'border-transparent']
                : 'bg-theme-input border-theme-disabled'
        ]},[_c('check-icon',{staticClass:"w-3.5 h-3.5 text-white",class:_vm.isChecked ? 'opacity-100' : 'opacity-0'})],1),(_vm.$slots.default)?_c('span',{staticClass:"text-sm text-theme-base leading-normal"},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }